module.exports = __webpack_public_path__ + "static/treyideker-2e9f5e65fe4d442f06138a80defc821f.jpg";